import { APP_NAME } from '@lib/constants';
import { Box } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import css from './Logo.module.scss';
import logoText from '/src/assets/branding/starzero-logo-text.svg';
import logo from '/src/assets/branding/starzero-logo.png';

export const Logo = React.forwardRef<
  HTMLDivElement,
  { hideText?: boolean; href?: string; onClick?: React.MouseEventHandler } & Omit<
    React.HTMLAttributes<HTMLDivElement>,
    'onClick'
  >
>(({ hideText = false, href, onClick, ...props }, ref) => {
  const inner = (
    <>
      <img className={css.logoImage} src={logo} alt="logo" />
      <img
        className={css.logoText}
        src={logoText}
        alt={APP_NAME}
        style={{ visibility: hideText ? 'hidden' : 'visible' }}
      />
    </>
  );

  return (
    <Box {...props} ref={ref} className={css.logoContainer}>
      {onClick ? (
        <div
          className={css.logo}
          onClick={onClick}
          role="button"
          tabIndex={0}
          style={{ cursor: 'pointer' }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') onClick(e as any);
          }}
        >
          {inner}
        </div>
      ) : (
        <Link to={href || '/'} className={css.logo}>
          {inner}
        </Link>
      )}
    </Box>
  );
});

Logo.displayName = 'Logo';
